import { useState, useRef } from 'react'
import { useNavigate } from "react-router";
import MaterialTable, { Options } from '@material-table/core';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import { urls, route } from '../route';
import { deleteApiWorkout_typeWorkouttypeid } from '../services/workout.type';
import { WorkoutType } from '../models/WorkoutType';
import { loadTableData } from './loaders';
import { confirmAndDelete } from '../utils';
import { getApiExercise_typeList } from '../services/workout.type.service';
export const ExerciseTypesList = () => {
    const history = useNavigate();
    const ref = useRef<any>();
    const [pagination,] = useState<Options<WorkoutType>>({
        actionsColumnIndex: -1,
        selection: true,
        maxColumnSort: 0,
        pageSize: 10,
    });
    // function groupWorkoutTypes = async (o: Promise<WorkoutTypes>) => {
    //     const workoutTypes = o.items.reduce((acc: any, value) => {
    //         if (acc[value.id]) {
    //             acc[value.id].progressions.push(value.progressions)
    //         }
    //         else {
    //             acc[value.id] = value
    //         }
    //         return acc
    //     }, {})
    //     return { items: Object.values(workoutTypes) }


    // }

    return <div>
        <MaterialTable<WorkoutType>
            title="Exercise Types"
            options={pagination}
            tableRef={ref}
            columns={[
                { title: "Id", field: "id", cellStyle: { width: "5%" } },
                { title: "Name", field: "name", width: "90%" },
                {
                    title: 'Tools',
                    render: (e) => (<>
                        <IconButton onClick={() => history(`/app/exercise-type/edit/${e.id}`)} style={{ float: "right" }}><Icon>edit</Icon></IconButton>
                        <IconButton onClick={confirmAndDelete(e, deleteApiWorkout_typeWorkouttypeid, ref)} style={{ float: "right" }}><Icon>delete</Icon></IconButton>
                    </>)
                }
            ]}
            data={loadTableData(getApiExercise_typeList)}
            actions={[{
                icon: "delete",
                tooltip: "Delete",
                onClick: async (event, data) => {
                    const confirmation = window.confirm("Are you sure you want to delete the selected items?")

                    if (confirmation && Array.isArray(data)) {
                        for (const i of data) {
                            try {

                                await deleteApiWorkout_typeWorkouttypeid(i.id);
                            } catch (e) {

                            }
                        }
                        if (ref.current) {
                            ref.current.onQueryChange();
                        }
                    }
                }
            }, {
                icon: "add",
                tooltip: "Add New",
                isFreeAction: true,
                onClick: () => history(route(urls.exerciseTypeAdd)),
            }]}
        />
    </div>
}